import type { ComponentProps } from "react";
import { t } from "ttag";

import { KlarnaLogo } from "@/assets";
import { Button } from "@/shared/ui";
import { tw } from "@/shared/utils";

export const KlarnaButton = ({
  className,
  ...props
}: Omit<ComponentProps<typeof Button>, "variant">) => (
  <Button
    size="lg"
    className={tw(
      "bg-[#0B051D] font-medium hover:bg-[#0B051D] focus:bg-[#0B051D] focus:ring-0 active:bg-[#0B051D]",
      className,
    )}
    {...props}
  >
    {t`Pay with`}{" "}
    <img src={KlarnaLogo} alt="Pay with Klarna" className="w-12 shrink-0" />
  </Button>
);
